<template>
  <div class="latest-wrapper">
    <Head :title="$tc('header.back')" />
    <!-- <Foot /> -->

    <div class="latest-inner" v-if="channelData">
      <div class="latest-list" v-if="list && list.length">
        <h4 class="page-title">
          <span>{{ $tc("channel.latest") }}</span>
        </h4>
        <news-list :list="list"></news-list>
        <p class="loading-notice" @click="getLatestData">
          {{
            isLoading
              ? $tc("load.loading")
              : lastList.length >= pageSize
              ? $tc("load.more")
              : $tc("load.nomore")
          }}
        </p>
      </div>
    </div>
    <Empty :emptydata="emptydata" v-if="emptydata" />
  </div>
</template>

<script>
import NewsList from '@/components/Channel/NewsList.vue'

import { mapMutations } from 'vuex'

export default {
    name: 'Channel',
    data () {
        return {
            id: '',
            channelData: null,
            list: [],
            lastList: [],
            pageSize: 10,
            lastDataId: '',
            isLoading: false,
            emptydata: null
        }
    },
    components: {
        NewsList
    },
    created () {
        this.id = this.$route.params.id
        this.getLatestData()
    },
    mounted () {
        this.$Common.pullLoadData(this.getLatestData)
        this.$nextTick(() => {
            this.$Common.pageShare()
        })
        this.$Common.track('load', {
            name: '最新报道',
            id: this.id,
            type: '资讯'
        })
    },
    methods: {
        ...mapMutations(['setShowLoading', 'setToastData']),
        getLatestData () {
            if (
                this.isLoading ||
                (this.lastDataId && this.lastList.length < this.pageSize)
            ) {
                return
            }
            this.isLoading = true
            this.$Api
                .getChannelList({
                    channelId: this.id,
                    pageSize: this.pageSize,
                    lastDataId: this.lastDataId,
                    queryType: 2
                })
                .then(data => {
                    if (data) {
                        this.channelData = data
                        this.list.push(...(data.list || []))
                        this.lastList = data.list || []
                        this.lastDataId = data.lastDataId || ''
                    }
                    if (!this.list.length) {
                        this.emptydata = {
                            type: 'nodata'
                        }
                    } else {
                        this.emptydata = null
                    }
                    this.isLoading = false
                    this.setShowLoading(false)
                })
                .catch(() => {
                    if (!this.lastDataId) {
                        this.emptydata = {
                            type: 'nonetwork'
                        }
                    } else {
                        this.setToastData({
                            text: this.$t('default.failed')
                        })
                    }
                    this.isLoading = false
                    this.setShowLoading(false)
                })
        }
    }
}
</script>

<style lang="scss">
.latest-wrapper {
  font-size: 0;
  padding-bottom: 13.889vw;
  .latest-list {
    .news-list-wrapper {
      position: relative;
      margin-top: -4.63vw;
    }
  }
}
</style>
